import { Box, Select, Option, Typography } from "@mui/joy";
import { useEffect, useState } from "react";
import { Paintbrush } from "lucide-react";

interface IVentilationPainted {
    value: string | null;
    onChange: (value: string) => void;
    loading?: boolean;
    showNA?: boolean;
}

export function VentilationPainted(props: IVentilationPainted) {
    const { value, onChange, loading, showNA } = { ...props };
    const [isPainted, setIsPainted] = useState<string | null>(null);

    const handleUpdate = (event: any, newValue: string | null) => {
        if (loading) return;
        const selectedValue = newValue || "";
        setIsPainted(selectedValue);
        onChange(selectedValue);
    };

    useEffect(() => {
        if (value) {
            setIsPainted(value);
        }
    }, [value]);

    return (
        <Box flex={1}>
            <Typography level="body-sm" sx={{ fontWeight: "md", mb: 0.5 }}>
                Ventilation Painted
            </Typography>

            <Select
                placeholder="Select option"
                value={isPainted}
                onChange={handleUpdate}
                disabled={loading}
                startDecorator={<Paintbrush size={16} />}
                slotProps={{ listbox: { sx: { zIndex: 10001 } } }}
            >
                <Option value="Yes">Yes</Option>
                <Option value="No">No</Option>
                {showNA && <Option value="N/A">N/A</Option>}
            </Select>
        </Box>
    );
}
